import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Dropdown, Menu, Button } from 'antd';
import { DownOutlined, UpOutlined, GlobalOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { selectLanguage } from '../../redux/authentication/actions';

function LanguageDropdown() {
  const location = useLocation();
  const isResetPasswordPage = location.pathname.includes('reset-password');

  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    const storedLang = localStorage.getItem('setLang');
    if (isResetPasswordPage && !storedLang) return 'English';
    switch (storedLang) {
      case 'en':
        return 'English';
      case 'ita':
        return 'Italian';
      default:
        return 'Italian';
    }
  });
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch();
  const storedLang = localStorage.getItem('setLang');
  const language = useSelector((state) => state?.auth?.language);

  useEffect(() => {
    if (isResetPasswordPage && !storedLang) {
      setSelectedLanguage('English');
      dispatch(selectLanguage('en'));
      return;
    }
    if (language?.length < 0) {
      dispatch(selectLanguage(storedLang || 'ita'));
    }
  }, [isResetPasswordPage, storedLang]);

  const handleMenuClick = (e) => {
    setSelectedLanguage(e.key);
    setVisible(false); // Close dropdown after selection
    dispatch(selectLanguage(e.key === 'English' ? 'en' : 'ita'));
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="English">English</Menu.Item>
      <Menu.Item key="Italian">Italian</Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']} visible={visible} onVisibleChange={setVisible}>
      <Button
        type="text"
        icon={<GlobalOutlined />}
        onClick={() => setVisible(!visible)}
        // style={{ display: 'flex', alignItems: 'center' }}
      >
        {selectedLanguage}
        {visible ? <UpOutlined style={{ fontSize: '15px' }} /> : <DownOutlined style={{ fontSize: '15px' }} />}
      </Button>
    </Dropdown>
  );
}

export default LanguageDropdown;
